<div [ngClass]="{
        'clickable': clickable,
        'standalone': standalone()
      }"
    class="d-flex flew-row m-0 p-2 rounded-2 gap-4"
    (click)="clickable ? focus() : ''">
    @if (selectableForAlteration || selectableForDeletion) {
        <div class="m-0 d-flex justify-content-center checkbox">
            <input (click)="onCheckUncheck($event)"
                [checked]="selected"
                [id]="'selectAnimal-'+ animal()?.id"
                class="form-check-input m-auto p-2"
                type="checkbox"
                value=""/>
        </div>
    }

    <div [ngClass]="{
             'checkbox-compensation': !selectableForAlteration && !selectableForDeletion
         }"
         class="d-flex justify-content-center align-items-center">
         <app-animal-profile-picture [animal]="animal()" />
    </div>
    <div class="m-0 d-flex flex-column gap-1">
        <div class="d-flex align-items-center">
            <app-spinner [loading]="loading()" class="m-auto"></app-spinner>
        </div>
        @if (!loading()) {
            <div class="fw-bold d-flex gap-2 align-items-center">
                <span>{{ animal()?.visualTag || '-' }}</span>
                <span>
                    @if (oop()) {
                        <span><app-oop-svg
                                [height]="'20px'"
                                [width]="'20px'"
                                class="pointer img-fluid img-max m-auto"></app-oop-svg></span>
                    }
                    @if (stoppedMoving()) {
                        <span><app-stopped-moving-svg
                                [height]="'20px'"
                                [width]="'20px'"
                                class="pointer img-fluid img-max m-auto"></app-stopped-moving-svg></span>
                    }
                    @if (abnormalActivity()) {
                        <span><app-abnormal-activity-svg
                                [height]="'20px'"
                                [width]="'20px'"
                                [high]="abnormalActivityIsHigh()"
                                class="pointer img-fluid img-max m-auto"></app-abnormal-activity-svg></span>
                    }
                    @if (animal()?.synchronizationStatus === SynchronizationStatus.syncPending) {
                        <span><i class="fa-solid fa-hourglass-half color-warning"></i></span>
                    }
                </span>
            </div>
            <app-animal-status-bar
                [animal]="animal()"
                [observingDeviceId]="observingDeviceId()"/>
            <app-animal-details-bar
                [animal]="animal()"
                [observingDeviceId]="observingDeviceId()"
                [showBatteryLevel]="false"/>
        }
    </div>
</div>
